<div [hidden]="hideButtons" *ngIf="togoMode ? true : party?.checkin_time" class="flex">
  <button
    *ngIf="voicePageNotificationEnabled && !togoMode"
    class="btn btn-info-outline btn-icon mr-2"
    placement="top"
    container="body"
    [ngbTooltip]="!isMobile ? 'Call' : ''"
    (click)="notifyActions?.voicePage(party)"
    (mousedown)="callBtnFocus[index] = true"
    (mouseup)="callBtnFocus[index] = false"
    [disabled]="notifyActions?.disableMessageButton(party)"
    angularticsCategory="waitlist"
    id="call-party-{{index}}"
    angulartics2On="click"
    angularticsAction="sent ready call">
    <tr-icon [icon]="icon.call" [color]="callBtnFocus[index] ? color.white : color.blue" classes="icon-secondary"></tr-icon>
  </button>
  <button
    class="btn btn-info btn-icon"
    placement="top"
    container="body"
    [ngbTooltip]="!isMobile ? 'Text' : ''"
    (click)="notifyActions?.smsPage(party)" id="text-party-{{index}}"
    [disabled]="notifyActions?.disableMessageButton(party)"
    angularticsCategory="waitlist"
    angulartics2On="click"
    angularticsAction="sent ready sms">
    <tr-icon [icon]="icon.send" [white]="true"></tr-icon>
  </button>
</div>

<ul class="list-unstyled tr-icon-list mb-1 mt-2">
  <li
    *ngFor="let msg of displayMessages"
    [ngClass]="{'danger':!msg.label}"
    class="message-row"
  >
    <ng-container *ngIf="shouldRender(msg)">
      <span class="message-row-icon">
        <tr-loader *ngIf="msg.status_sent === 'inProcess' && msg.time >= (now - 60000)" [isSpinner]="true"></tr-loader>
        <tr-icon *ngIf="msg.status_sent === 'sent'" [icon]="icon.complete" classes="tr-bullet"></tr-icon>
        <tr-icon
          *ngIf="msg.status_sent === 'not_sent' || (msg.status_sent === 'inProcess' && msg.time < (now - 60000))"
          classes="tr-bullet"
          [icon]="icon.exclamation"
        ></tr-icon>
        <tr-icon *ngIf="!msg.label" [icon]="icon.send" classes="tr-bullet"></tr-icon>
      </span>
      <span class="message-row-text">
        <span *ngIf="msg.label && msg?.label !== 'chat'">
        @if (msg.data?.retryOf) {
          <span *ngIf="msg.status_sent === 'inProcess'">Retrying {{ msg.label | notificationLabel | titlecase }} {{ msg.type | prettifyNotificationType }}</span>
          <span *ngIf="msg.status_sent === 'sent'">Retried {{ msg.label | notificationLabel | titlecase }} {{ msg.type | prettifyNotificationType }}</span>
          <span *ngIf="msg.status_sent === 'not_sent'">Retry failed: {{ msg.label | notificationLabel | titlecase }} {{ msg.type | prettifyNotificationType }}</span>
        } @else {
          {{ msg.label | notificationLabel | titlecase }} {{ msg.type | prettifyNotificationType }}
        }
        </span><span *ngIf="!msg.label || msg.label === 'chat'" [innerHTML]="(msg?.Body || msg?.message)"></span><span *ngIf="notificationTime === notificationTimeEnum.Absolute"> ({{ msg.time | trDateFormat:'M/D h:mm a': timezone}})</span><span *ngIf="notificationTime === notificationTimeEnum.Relative"> ({{ (now - msg.time) | trTimeDelta }} ago)</span>
      </span>
      <small
        *ngIf="msg.status_sent === 'not_sent' && msg.data?.failureReason"
        class="message-row-failure text-muted"
      >{{ msg.data.failureReason }}</small>
    </ng-container>
  </li>
  <li *ngIf="showViewAllLink">
    <a class="text-link" role="button" (click)="viewAllClick.emit()">View all</a>
  </li>
</ul>
